var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "alpheios-grammar" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.mustShowTitles,
            expression: "mustShowTitles",
          },
        ],
        staticClass: "alpheios-grammar__titles",
      },
      [
        _c("h1", { staticClass: "alpheios-panel__title" }, [
          _vm._v(_vm._s(_vm.l10n.getText("LABEL_BROWSE_GRAMMAR"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.languageList, function (languageItem, langIndex) {
          return _c(
            "div",
            {
              key: langIndex,
              staticClass: "alpheios-grammar__block alpheios-clickable",
              class: { open: !languageItem.collapsed },
            },
            [
              _c(
                "p",
                {
                  staticClass: "alpheios-grammar__block__title",
                  on: {
                    click: function ($event) {
                      return _vm.collapseLanguage(languageItem.languageCode)
                    },
                  },
                },
                [
                  _vm._v(_vm._s(languageItem.title) + "\n          "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: languageItem.collapsed,
                          expression: "languageItem.collapsed",
                        },
                      ],
                    },
                    [_vm._v("[+]")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !languageItem.collapsed,
                          expression: "!languageItem.collapsed",
                        },
                      ],
                    },
                    [_vm._v("[-]")]
                  ),
                ]
              ),
            ]
          )
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.waitingForGrammar,
            expression: "waitingForGrammar",
          },
        ],
        staticClass: "alpheios-grammar__frame-progress",
      },
      [
        _c("progress-bar", {
          attrs: { text: _vm.l10n.getText("PLACEHOLDER_GRAMMAR_DATA_LOADING") },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.currentUrl
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.languageList[_vm.currentLanguageCode].collapsed,
                expression: "!languageList[currentLanguageCode].collapsed",
              },
            ],
            staticClass: "alpheios-grammar__frame-cont",
          },
          [
            _c(
              "div",
              { staticClass: "alpheios-grammar__button--show-titles-block" },
              [
                _c(
                  "alph-tooltip",
                  {
                    attrs: {
                      tooltipText: _vm.showHideTooltipValue,
                      tooltipDirection: "bottom-left",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "alpheios-button-primary alpheios-svg-index",
                        on: { click: _vm.showHideTitles },
                      },
                      [_c("grammar-icon")],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alpheios-grammar__button--back-block" },
              [
                _c(
                  "alph-tooltip",
                  {
                    attrs: {
                      tooltipText: _vm.l10n.getText("TOOLTIP_BACK_TO_INDEX"),
                      tooltipDirection: "bottom-left",
                    },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "alpheios-button-primary alpheios-svg-index",
                        on: { click: _vm.returnToIndex },
                      },
                      [_c("back-icon")],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("iframe", {
              staticClass: "alpheios-grammar__frame",
              attrs: { src: _vm.currentUrl, scrolling: "yes" },
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.updatedGrammarData &&
    _vm.currentLanguageCode &&
    _vm.languageList[_vm.currentLanguageCode].provider
      ? _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.languageList[_vm.currentLanguageCode].collapsed,
                expression: "!languageList[currentLanguageCode].collapsed",
              },
            ],
            staticClass: "alpheios-grammar__provider",
          },
          [
            _vm._v(
              _vm._s(_vm.languageList[_vm.currentLanguageCode].provider) +
                "\n    "
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }